export default "__VITE_ASSET__BgV7j50R__"